/* eslint-disable react/jsx-indent */
import React from 'react';
import PropTypes from 'prop-types';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import WizardStepDeleteButton
  from 'Views/Page/Content/Templates/WizardTemplates/WizardStepTemplate/Content/WizardStepDeleteButton';
import TextListCard from 'Components/ComponentLibrary/Molecules/TextListCard';
import fr from 'facet-rest';
import Button1 from 'Components/ComponentLibrary/Components/Buttons/Button1';
import Typography from '@material-ui/core/Typography';
import MetaFormFields from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/MetaFormFields';
import BodyText from 'Components/ComponentLibrary/Atoms/Text/BodyText';
import PageContentTop from 'Components/ComponentLibrary/Molecules/Page/PageContentTop';
import PageContentContainer from 'Components/ComponentLibrary/Molecules/Page/PageContentContainer';
import { FDTitleText, FDBox } from '@facet-wealth/design';
import PhotoUploaderPicker from './PhotoUploaderPicker';

const styles = theme => ({
  content: {
    width: '100%',
  },
  imageUrlContainer: {
    display: 'flex',
    placeContent: 'center',
    width: '100%',
    maxWidth: theme.dimensions.md,
    maxHeight: theme.dimensions.sm,
    alignSelf: 'center',
  },
  image: {
    maxHeight: '100%',
    maxWidth: '100%',
    objectFit: 'contain',
  },
  body: {
    fontWeight: theme.typography.fontWeightBold,
    padding: 0,
  },
  photoUploaderPicker: {
    padding: 0,
  },
  fields: {
    width: '100%',
  },
});

const Content = ({
  classes,
  setCollection,
}) => {
  const {
    resource,
  } = useMetaLayoutContext();

  async function handleDelete() {
    if (resource.id() > 0 && resource.meta().action('DELETE')) {
      return resource.delete();
    }
    return null;
  }

  function handleDeleteSuccess(responseCollection) {
    setCollection(responseCollection);
  }

  return (
    <PageContentContainer>
      <PageContentTop
        resource={resource}
        badgeImage={resource.attr('badgeImage')}
        badgeImageAlt={resource.attr('badgeImageAlt')}
        title={resource.attr('title')}
        subtitle={resource.attr('subtitle')}
      />
      {/* ---------- Photo Uploader ---------- */}
      <PhotoUploaderPicker
        className={classes.photoUploaderPicker}
        resource={resource}
      />
      {resource.attr('imageUrl') && (
        <Box className={classes.imageUrlContainer}>
          <img className={classes.image} alt={resource.attr('title')} src={resource.attr('imageUrl')} />
        </Box>
      )}
      { resource.relationship(fr.relationships.specificPageLink.name) && resource.relationship(fr.relationships.specificPageLink.name)?.meta('pageLocation') === 'top'
        ? <Button1
          color={'primary'}
          variant={'underlined'}
          onClick={async () => { const newItemCollection = await resource.relationship(fr.relationships.specificPageLink.name).link('related').get(); setCollection(newItemCollection); }}
          test={'specific-page-link-button'}
        >
          <Typography
            variant="h6"
          >
            {resource.relationship(fr.relationships.specificPageLink.name)?.meta('prompt') || 'Review Information'}
          </Typography>
          </Button1>
        : null }
      {resource.attr('bodyTitle') && <FDTitleText value={resource.attr('bodyTitle') ?? ''} />}
      {resource.attr('body')
        && <BodyText className={classes.body} text={resource.attr('body')} test={'wizard-step-body'} />}
      {
          resource.attr('additionalDetailItems')
            ? <FDBox alignSelf={'center'}>
              <TextListCard
                title={resource.attr('additionalDetailTitle')}
                textArray={resource.attr('additionalDetailItems')}
              />
              </FDBox> : null}
      <Box className={classes.content}>
        <MetaFormFields
          className={classes.fields}
          resource={resource}
        />
        {resource.meta().action('DELETE') ? <WizardStepDeleteButton
          onDelete={handleDelete}
          onDeleteSuccess={handleDeleteSuccess}
          dialogProps={{
            title: 'Are you sure?',
            message: 'Removing this item will delete all of its information. This cannot be undone.',
            cancelLabel: 'Nevermind',
            confirmLabel: 'Remove',
          }}
        /> : null}
      </Box>
    </PageContentContainer>
  );
};

Content.propTypes = {
  classes: PropTypes.object.isRequired,
  setCollection: PropTypes.func.isRequired,
};

export default withStyles(styles)(Content);
